
jQuery(function($){
	/**
	 * Set cookieBar variables and run function
	 *
	 * https://github.com/kovarp/jquery.cookieBar
	 */
	
	/**
	 * Run functions
	 */
	blockSlider();
	rwdMenu();
	goTo();
	translations();
	contactMap();
	productFilters();
	showSearchForm();
	certyficates();
	accordion();
	productDetails();
	goToTop();
	contactAddress();
	productDetailsMobile();
	productPhoto();
	inifFancybox();

	jQuery(function ($) {
    $('#dane-techniczne table').wrap('<div class="table-wrapper"></div>');
});

function inifFancybox() {
  console.log("inicjuję fancyboxa");

  Fancybox.bind("[data-fancybox]", {
    zoomEffect: false,

    Carousel: {
      Thumbs: false,

      // TO JEST KLUCZ W FANCYBOX 6:
      // konfiguracja zoom/pan dla obrazów jest w Carousel.Zoomable.Panzoom
      Zoomable: {
        Panzoom: {
          // default: bez zoom przez inputy
          wheel: false,
          pinch: false,

          // wyłącz akcje klik/dblclick, które często robią "toggleZoom"
          clickAction: false,
          dblClickAction: false,

          // skale (baza)
          minScale: 1,
          maxScale: 1,
        },
      },
    },

    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ["close"],
      },
    },

    on: {
      // Dodatkowo WARUNKOWO: jeśli obraz jest większy niż viewport,
      // to twardo blokujemy możliwość powiększenia (maxScale=1)
      done: (fancybox, slide) => {
        if (!slide || slide.type !== "image") return;

        const img = slide.imageEl;
        if (!img) return;

        const biggerThanViewport = img.naturalWidth > window.innerWidth;

        // W fancybox/panzoom instance jest dostępny przez slide.panzoom
        // (w razie różnic wersji: fallback na fancybox.getPanzoom?.())
        const pz = slide.panzoom || fancybox.getPanzoom?.();
        if (!pz) return;

        if (biggerThanViewport) {
          // blokada zoom:
          pz.option?.("minScale", 1);
          pz.option?.("maxScale", 1);

          // wymuś aktualną skalę na 1
          pz.zoomTo?.(1);
        }
      },

      destroy: () => {
        const videos = document.querySelectorAll(".inline-movies");
        videos.forEach((video) => video.pause());
      },
    },
  });
}
	function productPhoto() {
		
		var $section = $('.single-product__header .top-product-section');
		if (!$section.length) return;

		var windowWidth = $(window).width();
		if (windowWidth <= 1024) return;

		var sectionHeight = $section.outerHeight();
		console.log(sectionHeight);

		if (sectionHeight && sectionHeight < 500) {
			$('.single-product__header-wrapper .img-wrapper img')
				.css('width', (sectionHeight + 50) + 'px');
		}
	}

	function contactAddress() {
		var windowWidth = $(window).width();
		if (windowWidth > 1024) {
		$(".main-address > svg").click(function(event) {

			event.preventDefault();
			$('.main-address > div').removeClass('active')
			$(this).parent('div').children('div').toggleClass('active');
			$(this).toggleClass('act');
		  });
		} else {
			$(".main-address > svg").click(function(event) {
				event.preventDefault();
				$('.main-address > div').removeClass('active');
				$(this).parent('div').children('div').addClass('active');
				$('.main-address > svg').removeClass('active');
				$(this).addClass('act');
			});
		}
	  }

	function goToTop() {
		$("#to-top").click(function(event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: 'smooth' });
			return false;
		  });
	  }

	function productDetails() {
		var windowWidth = $(window).width();
		if (windowWidth > 1024) {
		$('.single-product__description-nav .container > a').click(function(event) {
			event.preventDefault();
			var hash = $(this).attr('href'); 
			$('.single-product__description-nav .container > a').removeClass('active');
			$(this).addClass('active');
			$('.single-product__description-content > div').hide();
			$('.single-product__description-content > div'+hash).show();
			$('html, body').animate({
					scrollTop: $('.single-product__description-nav').offset().top - 100 
				}, 500);
		});
	}
		
	}

	function productDetailsMobile() {
		$('.single-product__description-nav .mobile-show-content').click(function(event) {
			event.preventDefault();
			var hash = $(this).attr('href'); 
			$(this).toggleClass('active');
			$('.single-product__description-content > div'+hash).slideToggle(500);
		});
		
	}

	function accordion() {
		$('.show-accordion').click(function(event) {
			event.preventDefault();
			var hash = $(this).attr('href'); 
			$(this).toggleClass('active');
			$('.accordion-group'+hash).slideToggle(500);
		});
	}

	$(function(){
		loopcounter('myCountdown');
	  });
	  function certyficates() {
		$('.show-certificates').click(function(event) {
			event.preventDefault();
			var hash = $(this).attr('href'); 
			$(this).toggleClass('active');
			$('.certyficates-group'+hash).slideToggle(500);
		});
	}
	function showSearchForm() {
		$('.show-search-form > a').click(function(event) {
			event.preventDefault();
			$('form#search').slideToggle(0);
		});
	}

	$(document).on("click", ".reset-filters", function (e) {
		e.preventDefault();

		window.location.href = window.location.origin + window.location.pathname;
	});

	if (
		window.location.search.indexOf('title=') !== -1 ||
		window.location.search.indexOf('group=') !== -1 ||
		window.location.search.indexOf('p=') !== -1
	) {
		restoreFiltersFromUrl();
	}

	window.addEventListener('popstate', function() {
		restoreFiltersFromUrl();
	});
	function productFilters() {

		

		$('fieldset > a').click(function(event) {
			event.preventDefault();
			var targetId = $(this).attr('href');
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(targetId).slideUp();
				return;
			}
			$('fieldset > a').removeClass('active');
			$('fieldset > div').slideUp();
			$(targetId).slideToggle();
			$(this).toggleClass('active');
			
		});
	
		// 2. Zaznaczanie wszystkich checkboxów w danej sekcji
		$('.check-all').click(function(event) {
			event.preventDefault();
			$(this).closest('div').next('.list').find('input[type="checkbox"]').prop('checked', true);
		});
	
		// 3. Odznaczanie wszystkich checkboxów w danej sekcji
		$('.reset').click(function(event) {
			event.preventDefault();
			$(this).closest('div').next('.list').find('input[type="checkbox"]').prop('checked', false);
		});
	
		// 4. Zamykanie sekcji po kliknięciu na przycisk "Zastosuj"
		$('.close').click(function(event) {
			event.preventDefault();
			$(this).closest('fieldset > div').slideUp();
			$('fieldset > a').removeClass('active');
		});

		$(document).click(function(e) {
            if (!$(e.target).closest('fieldset > div, fieldset > a').length) {
                closeAllDivs();
            }
        });

		$('.products-filters__menu a').on('click', function(e) {
    e.preventDefault();

    $('.products-filters__menu a').removeClass('active');
    $(this).addClass('active');

    var href = $(this).attr('href');
    var termId = href === '#term-all' ? 'all' : href.replace('#term-', '');

    resetAllProductFiltersExceptGroup(termId);

    applyFilters();
});

		$('.show-products').on('click', function(e) {
    e.preventDefault();

    var hrefValue = $(this).attr('href');

    $('.products-filters__menu a').removeClass('active');
    $('.products-filters__menu a[href="' + hrefValue + '"]').addClass('active');

    var termId = hrefValue.replace('#term-', '');

    resetAllProductFiltersExceptGroup(termId);

    applyFilters();
});
	
		// Filtrowanie produktów po kliknięciu przycisku "Zapisz" lub wyszukiwaniu
		$('.search-by-name button').on('click', function(e) {
			e.preventDefault();
			applyFilters();
		});

		$('.save').on('click', function(e) {
			e.preventDefault();
			applyFilters();
		
			var $fieldsetDiv = $(this).closest('fieldset > div'); // np. #diameter
			var $fieldset = $fieldsetDiv.closest('fieldset');
			var selected = [];
		
			// Zbierz zaznaczone checkboxy w tej sekcji
			$fieldsetDiv.find('input[type="checkbox"]:checked').each(function() {
				selected.push($(this).siblings('span').text()); // pobieramy tekst obok checkboxa
			});
		
			// Usuń stare podsumowanie (jeśli istnieje)
			$fieldset.find('.selected-values').remove();
		
			// Jeśli są wybrane elementy, dodaj podsumowanie
			if (selected.length > 0) {
				$('<span class="selected-values">' + selected.join(', ') + '</span>')
					.insertAfter($fieldset.find('a[href="#' + $fieldsetDiv.attr('id') + '"]'));
			}
		
			$fieldsetDiv.slideUp();
			$('fieldset > a').removeClass('active');
		});
		

		$('.search-by-name button').on('click', function(e) {
			$('.products-filters__menu a').removeClass('active');
			$('.products-filters__menu a:first').addClass('active');
		});
	}

	function resetAllProductFiltersExceptGroup(termId) {
    // wyczyść tekst
    $('#name').val('');

    // odznacz wszystkie checkboxy
    $('#filters input[type="checkbox"]').prop('checked', false);

    // usuń podsumowania przy filtrach
    $('#filters .selected-values').remove();

    // ustaw tylko grupę
    if (termId && termId !== 'all') {
        $('#group input[name="group[]"][value="' + termId + '"]').prop('checked', true);
    }
}

	function applyFilters(page = 1, scrollToResults = true, pushUrl = true) {
    var filters = $('#filters').serialize();
    $('.products-filters__list').addClass('loading');

    $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'filter_products',
            filters: filters,
            paged: page
        },
        success: function(data) {
			$('.products-filters__list').html(data.html);
			$('.pagination-wrapper').html(data.pagination);

			// aktywne grupy po wynikach filtrowania
			$('.products-filters__menu a').removeClass('active');

			if (Array.isArray(data.active_groups) && data.active_groups.length) {
				data.active_groups.forEach(function(termId) {
					$('.products-filters__menu a[href="#term-' + termId + '"]').addClass('active');
				});
			} else {
				$('.products-filters__menu a[href="#term-all"]').addClass('active');
			}

			if (pushUrl) {
				updateFiltersUrl(page);
			}

			if (scrollToResults) {
				$('html, body').animate({
					scrollTop: $('.products-filters__list').offset().top - 50
				}, 500);
			}

			$("#products-table").stupidtable();
		},
        complete: function() {
            $('.products-filters__list').removeClass('loading');
        }
    });
}

function getCurrentFiltersPage() {
    var urlParams = new URLSearchParams(window.location.search);
    var pageParam = urlParams.get('p');

    if (!pageParam) {
        return 1;
    }

    // obsługa zarówno "3" jak i "P03"
    pageParam = String(pageParam).toUpperCase().replace(/^P/, '');
    var page = parseInt(pageParam, 10);

    return page > 0 ? page : 1;
}

function updateFiltersUrl(page) {
    var url = new URL(window.location.href);

    var name = $('#name').val().trim();
    var activeGroup = $('#group input[name="group[]"]:checked').val();

    if (name) {
        url.searchParams.set('title', name);
    } else {
        url.searchParams.delete('title');
    }

    if (activeGroup) {
        url.searchParams.set('group', activeGroup);
    } else {
        url.searchParams.set('group', 'all');
    }

    if (page > 1) {
        url.searchParams.set('p', 'P' + String(page).padStart(2, '0'));
    } else {
        url.searchParams.delete('p');
    }

    history.pushState({}, '', url.toString());
}

function restoreFiltersFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    var titleParam = urlParams.get('title');
    var groupParam = urlParams.get('group');
    var pagedParam = getCurrentFiltersPage();

    // reset stanu
    $('#name').val('');
    $('#filters input[type="checkbox"]').prop('checked', false);
    $('.products-filters__menu a').removeClass('active');
    $('#filters .selected-values').remove();

    if (titleParam) {
        $('#name').val(titleParam);
    }

    if (groupParam && groupParam !== 'all') {
        $('#group input[value="' + groupParam + '"]').prop('checked', true);
        $('.products-filters__menu a[href="#term-' + groupParam + '"]').addClass('active');
    } else {
        $('.products-filters__menu a[href="#term-all"]').addClass('active');
    }

    applyFilters(pagedParam, false, false);
}


	window.addEventListener('pageshow', function(event) {
    if (event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
        setTimeout(function() {
            restoreFiltersFromUrl();
        }, 200);
    }
});
	
	// Obsługa kliknięcia na paginację
	$(document).on('click', '.products-filters__content-wrapper .pagination a', function(e) {
		e.preventDefault();
		var page = $(this).data('page');
		applyFilters(page);
	});
	
	

	function closeAllDivs() {
		$('fieldset > div').slideUp();
		$('fieldset > a').removeClass('active');
	}

	function contactMap() {
		$(".main-contact__map .buttons a").click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			console.log(href);
			if(href=='#europa') {
				$('#europa').show();
				$('#polska').hide();
				$('.departures-contact__sales__eu').show();
				$('.departures-contact__sales__pl').hide();
			} else {
				$('#europa').hide();
				$('#polska').show();
				$('.departures-contact__sales__pl').show();
				$('.departures-contact__sales__eu').hide();
			}
			$(".main-contact__map .buttons a").removeClass('active');
			$(this).addClass('active');
			
		});

		$(".main-contact__map #polska svg a, .main-contact__map #europa svg a").click(function(e) {
			e.preventDefault();
			var windowWidth = $(window).width();
			var href = $(this).attr('href');
			var href = href.substring(1, href.length);
			console.log(href);
			console.log('pppppppppppppppppppppppp');
			if('polska' == href) {
				$('#europa').hide();
				$('#polska').show();
				$(".main-contact__map .buttons a").removeClass('active');
				$('.main-contact__map .buttons a[href="#polska"]').addClass('active');
			}

			if (windowWidth > 768) {
				var parentOffset = $(this).parent().offset(); 

				var relX = e.pageX - parentOffset.left;
				var relY = e.pageY - parentOffset.top;
			}

			if (windowWidth > 1240) {
				var parentOffset = $(this).parent().offset(); 

				var relX = e.pageX - parentOffset.left;
				var relY = e.pageY - parentOffset.top ;
				if(href == 'podkarpackie') {
					var relX = e.pageX - parentOffset.left -350;
				} else if(href == 'lubelskie') {
					var relX = e.pageX - parentOffset.left -390;
				} else if(href == 'podlaskie') {
					var relX = e.pageX - parentOffset.left -300;
				} else if(href == 'mazowieckie') {
					var relX = e.pageX - parentOffset.left -200;
				} else {
					var relX = e.pageX - parentOffset.left -100;
				}
			}
			$('.main-contact__map .region').css({'left' : relX+'px', 'top' : relY +'px'});
			$('.main-contact__map .region').hide();
			$('.main-contact__map .region.'+href).show();
			
		});

		$('.close-contact').on('click', function (e) {
			e.preventDefault();
			$('.main-contact__map .region').hide();
		});

		$('.close-contact-main').on('click', function (e) {
			e.preventDefault();
			$('.main-address > div').removeClass('active');
		});
	}
	
	function translations() {
		var attachFile = $('#attch-file').text();
		$('.cd-upload-btn').text(attachFile);
	 }

	

	function goTo() {

		$(".go-to").click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			var pos = 5;
			jQuery('html, body').animate({
				scrollTop: jQuery(href).offset().top + pos
			  }, 500);
		});
	 }

	 (function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 180) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {
            $("header").addClass("scrolled");
			$('.go-to-top-button').fadeIn(300);
        
        } else {
            $("header").removeClass("scrolled");
			$('.go-to-top-button').fadeOut(300);
        }
		if (windowWidth > 1024) {
			if (scroll >= 550 ) {
				$(".home .show-search-form form").fadeOut(500);
				$(".home .show-search-form a").addClass('zoom')
			
			} else {
				$(".home .show-search-form form").fadeIn(500);
				$(".home .show-search-form a").removeClass('zoom')
			}
		}

    });


	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1140) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
                $('.site-header__navigation > ul').slideUp(500);
			    $('.site-header').removeClass('menu-opened');
                $('#hamburger').removeClass('open');
			});
			
			// Dodanie obsługi kliknięcia na rodzicu, aby zatrzymać propagację tylko na linkach
			$('.site-header__navigation .menu-item-has-children').on('click', function(event) {
				console.log('klik');
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
                    
				}
			});

            $('.site-header__navigation .sub-menu li > a').on('click', function(event) {
				event.stopPropagation();
                $('.site-header__navigation > ul').slideUp(500);
			    $('.site-header').removeClass('menu-opened');
                $('#hamburger').removeClass('open');
			});

			$('.site-header__navigation .sub-menu .sub-menu li > a').on('click', function(event) {
				event.stopPropagation();
                $('.site-header__navigation .sub-menu ul').slideUp(500);
			    $('.site-header').removeClass('menu-opened');
                $('#hamburger').removeClass('open');
			});
		}
	}
	  
	  
	  
	  
	

	function blockSlider() {
		jQuery('.header-slider').owlCarousel({
	loop: true,
	margin: 0,
	nav: true,
	items: 1,
	dots: true,

	autoplay: true,
	autoplayTimeout: 7000, // slajd widoczny 7s
	autoplaySpeed: 2000,   // przejście 2s

	smartSpeed: 2000,      // speed dla nav + dots
	navSpeed: 2000,
	dotsSpeed: 2000,

	singleItem: true,
	navText: ["<", ">"],
});

        jQuery('.right-slider').owlCarousel({
            animateIn: 'fadeIn',
			animateOut: 'fadeOut',
			loop:true,
			margin:0,
			nav:false,
			items:1,
			autoplay:true,
			autoplayTimeout:5000,
			autoplaySpeed: 1200,
			slideSpeed: 600,
			navSpeed: 1200,
			dotsSpeed: 1200,
			dots: true,
			singleItem: true,
			navText: ["<",">"],
		});

	

		jQuery('.references-slider').owlCarousel({
		  loop:true,
		  margin:20,
		  nav:true,
		  items:2,
		  autoplay:true,
		  autoplayTimeout:5000,
		  autoplaySpeed: 1200,
		  slideSpeed: 600,
		  navSpeed: 1200,
		  dotsSpeed: 1200,
		  dots: false,
		  singleItem: false,
		  navText: ["<",">"],

		  responsive:{
			0:{
			  
			  items:1,
			},
			850:{
			  items:2,
			},
			
		  }
		});

		jQuery('.portfolio-slider').owlCarousel({
			loop:true,
			margin:20,
			nav:true,
			items:5,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1200,
			slideSpeed: 600,
			navSpeed: 1200,
			dotsSpeed: 1200,
			dots: false,
			singleItem: false,
			navText: ["<",">"],
  
			responsive:{
			  0:{
				
				items:1,
			  },
			  850:{
				items:3,
			  },

			  1330:{
				items:5,
			  },
			  
			}
		  });

		  jQuery('.featured-products-slider').owlCarousel({
			loop:true,
			margin:20,
			nav:true,
			items:5,
			autoplay:false,
			autoplayTimeout:5000,
			autoplaySpeed: 1200,
			slideSpeed: 600,
			navSpeed: 1200,
			dotsSpeed: 1200,
			dots: false,
			singleItem: false,
			navText: ["<",">"],
			
  
			responsive:{
			  0:{
				
				items:1,
			  },
			  850:{
				items:2,
				stagePadding: 150,
			  },

			  1330:{
				items:2,
				stagePadding: 250,
			  },
			  
			}
		  });

		jQuery('.knowledge-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:2,
			autoplay:true,
			autoplayTimeout:5000,
			autoplaySpeed: 1200,
			slideSpeed: 600,
			navSpeed: 1200,
			dotsSpeed: 1200,
			dots: false,
			singleItem: false,
			navText: ["<",">"],
  
			responsive:{
			  0:{
				
				items:1,
			  },
			  850:{
				items:2,
			  },

			  1200:{
				items:3,
			  },
			  
			}
		  });

		  jQuery('.movies-slider').owlCarousel({
			loop:true,
			margin:28,
			nav:true,
			items:2,
			autoplay:false,
			autoplayTimeout:5000,
			autoplaySpeed: 1200,
			slideSpeed: 600,
			navSpeed: 1200,
			dotsSpeed: 1200,
			dots: false,
			singleItem: false,
			navText: ["<",">"],
  
			responsive:{
			  0:{
				
				items:1,
			  },
			  850:{
				items:2,
			  },

			  1200:{
				items:3,
			  },
			  
			}
		  });

		  jQuery('.testimonials-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:false,
			autoplayTimeout:5000,
			autoplaySpeed: 1200,
			slideSpeed: 600,
			navSpeed: 1200,
			dotsSpeed: 1200,
			dots: false,
			singleItem: false,
			navText: ["<",">"],

		  });
	 }

	
})